const resolve = (path, params) => {
  for (const [name, value] of Object.entries(params)) {
    path = path.replace(':' + name, value)
  }
  return path
}

export default ({ account, moment }) => {
  return {
    checkReport (check) {
      return resolve('/check/report/:user/:year/:check.json', {
        user: account.current.hid,
        year: moment(check.created_at).format('YYYY'),
        check: check.hid
      })
    },
    checkSerp (check, datacenter) {
      return resolve('/check/serp/:year/:month/:day/:user/:check_:datacenter.json', {
        year: moment(check.created_at).format('YYYY'),
        month: moment(check.created_at).format('MM'),
        day: moment(check.created_at).format('DD'),
        user: account.current.hid,
        check: check.hid,
        datacenter
      })
    },

    monitorHistory (monitor, date) {
      return resolve('/monitor/history/:user/:monitor/:year.json', {
        user: account.current.hid,
        monitor: monitor.hid,
        year: moment(date).format('YYYY')
      })
    },
    monitorReportList (date) {
      return resolve('/monitor/report-list/:user/:year.json', {
        year: moment(date).format('YYYY'),
        user: account.current.hid,
      })
    },
    monitorReport (date) {
      return resolve('/monitor/report/:year/:month/:day/:user.json', {
        year: moment(date).format('YYYY'),
        month: moment(date).format('MM'),
        day: moment(date).format('DD'),
        user: account.current.hid,
      })
    },
    monitorSerp (monitor, date) {
      return resolve('/monitor/serp/:year/:month/:day/:user/:monitor_:hour_:minute.json', {
        year: moment(date).format('YYYY'),
        month: moment(date).format('MM'),
        day: moment(date).format('DD'),
        hour: moment(date).format('HH'),
        minute: moment(date).format('mm'),
        user: account.current.hid,
        monitor: monitor.hid,
      })
    },

    urlMonitorReport () {
      return resolve('/url-monitor/report/:user.json', {
        user: account.current.hid,
      })
    },
    userNotes () {
      return resolve('/user/notes/:user/2021.json', {
        user: account.current.hid
      })
    },
    userNotifications () {
      return resolve('/user/notifications/:user.json', {
        user: account.current.hid
      })
    },

    resolve
  }
}